
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/categories",
      function () {
        return require("private-next-pages/[slug]/categories.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/categories"])
      });
    }
  